export default {
    // port: 8000,
    auth: {
        secretKey: "LeadSamPlan",
        token: "access-token"
    },
    origin: "https://samsungplanogram.leadinnovation.co.th/api1v1/",
    api: `https://samsungplanogram.leadinnovation.co.th/api1v1/`,
};